<div
  #colorSelect
  class="dropdown is-color-select"
  [ngClass]="{ 'is-large': isLarge, 'is-medium': isMedium, 'is-xlarge': isXLarge, 'is-filter': isFilter }"
  >
  <div class="dropdown-trigger" [ngClass]="{'is-medium': isMedium}">
    <button class="button" aria-haspopup="true" [ngClass]="{'is-medium': isMedium}" aria-controls="dropdown-menu2" (click)="showColorItemListClick(colorSelect)">
      <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="item-color" [ngStyle]="{ 'background-color': getItemColor(colorCode) }">&nbsp;</div>
          <div class="item-name" [ngClass]="{ 'is-empty': !label }">{{ label || placeholderLabel }}</div>
        </div>
        <div class="dropdown-arrow">
          <i class="icon icon-caret_up"></i>
        </div>
      </div>
    </button>
  </div>
  @if (isActive) {
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        @for (item of items; track item?.uId) {
          <div class="dropdown-item">
            <div fxLayout="row" fxLayoutAlign="space-between" class="color-select-item" (click)="selectColorItem(item)">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div class="item-color" [ngStyle]="{ 'background-color': getItemColor(item[itemColorCode]) }">&nbsp;</div>
                <div>{{ item[itemLabel] }}</div>
              </div>
              @if (item.uId === selectedUId) {
                <div class="pr-5">
                  <i class="icon icon-check_clear"></i>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
